import { createContext, useContext, useState, useEffect } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("afridi_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("afridi_email"));
  const [role, setRole] = useState(() => localStorage.getItem("afridi_role"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await api.get("/auth/me");
        setEmail(res.data.email);
        setRole(res.data.role);
        localStorage.setItem("afridi_role", res.data.role || "");
        setLoading(false);
      } catch {
        setToken(null);
        setEmail(null);
        setRole(null);
        localStorage.removeItem("afridi_token");
        localStorage.removeItem("afridi_email");
        localStorage.removeItem("afridi_role");
        setLoading(false);
      }
    };
    verify();
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("afridi_token", res.data.token);
    localStorage.setItem("afridi_email", res.data.email);
    localStorage.setItem("afridi_role", res.data.role || "");
    setToken(res.data.token);
    setEmail(res.data.email);
    setRole(res.data.role);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("afridi_token");
    localStorage.removeItem("afridi_email");
    localStorage.removeItem("afridi_role");
    setToken(null);
    setEmail(null);
    setRole(null);
  };

  return (
    <AuthCtx.Provider value={{ token, email, role, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
